import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/jornada`

    return {
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {
            return repository.put(`${baseUrl}/${id}`, params)
        },
        bloquear(id) {
            return repository.put(`${baseUrl}/bloquear/${id}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        destroySelected(params) {
            return repository.post(`${baseUrl}/delete`, params)
        },
        datatable(queryParms) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
    }
}